// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"fcaddd2b","389":"149fc8aa","732":"ab4dd3f5","977":"bda4001d"}[chunkId] + ".chunk.js";
};